import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { CircleNotch, ImageSquare } from "@phosphor-icons/react";
import { toast } from "sonner";

export const MK_STATUS = {
  rascunho: { label: "Rascunho", cls: "border-slate-200 bg-slate-50 text-slate-700" },
  aprovado: { label: "Aprovado", cls: "border-blue-200 bg-blue-50 text-blue-700" },
  publicado: { label: "Publicado", cls: "border-emerald-200 bg-emerald-50 text-emerald-700" },
};
export const DAYS_PT = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];

export const toISO = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const mondayOf = (d = new Date()) => {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12);
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return toISO(x);
};
export const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return toISO(d); };
export const dayIndex = (iso) => (new Date(`${iso}T12:00:00`).getDay() + 6) % 7;
export const fmtDM = (iso) => iso.slice(8, 10) + "/" + iso.slice(5, 7);

export async function downloadBlob(url, filename) {
  try {
    const res = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(href), 1000);
  } catch (e) {
    toast.error(apiError(e, "Falha no download"));
  }
}

export function captionOf(item) {
  return [item.text?.trim(), item.hashtags?.trim()].filter(Boolean).join("\n\n");
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }
}

export function ItemPreview({ item, version, className = "" }) {
  const [src, setSrc] = useState(null);
  const urlRef = useRef(null);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    api.get(`/marketing/items/${item.id}/image.png`, { responseType: "blob" }).then((r) => {
      if (!alive) return;
      const u = URL.createObjectURL(r.data);
      if (urlRef.current) URL.revokeObjectURL(urlRef.current);
      urlRef.current = u;
      setSrc(u);
    }).catch(() => {});
    return () => { alive = false; };
  }, [item.id, item.updated_at, version]);
  useEffect(() => () => { if (urlRef.current) URL.revokeObjectURL(urlRef.current); }, []);
  const aspect = item.type === "story" ? "aspect-[9/16]" : "aspect-[4/5]";
  return (
    <div className={`relative overflow-hidden rounded-lg bg-muted ${aspect} ${className}`} data-testid={`mk-preview-${item.id}`}>
      {src ? <img src={src} alt="" className="h-full w-full object-cover" />
        : <div className="flex h-full items-center justify-center text-muted-foreground">{item ? <CircleNotch className="animate-spin" /> : <ImageSquare />}</div>}
    </div>
  );
}
